import React from "react";
import styled from "styled-components";
import PresetIcon from "../atoms/PresetIcon";
import { ReactComponent as RobotIcon } from "../../assets/robot.svg";

const Messages = styled.ul`
  list-style-type: none;
  margin: 1rem 0;
  padding: 0;
  // max-width: 40ch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 1rem;

  .preset-holder {
    align-self: flex-end;
    display: flex;
    flex-direction: column;

    svg {
      align-self: flex-end;
      margin-bottom: 6px;
      rect,
      line,
      path,
      circle {
        stroke: ${(props) => props.theme.colors.color1};
      }
    }

    button {
      width: 7rem;
      align-self: flex-end;
    }
  }
`;

const MessageBubble = styled.li`
  flex: 0 0 auto;
  padding: 0.5em 1em;
  border-radius: 2em;
  background: white;
  border: 1px solid ${(props) => props.theme.colors.color1};

  &:nth-child(even) {
    align-self: flex-end;
    background: #74b9ff;
  }
`;

const PresetButton = styled.button`
  padding: 12px;
  border: 1px dotted ${(props) => props.theme.colors.color1} !important;
  width: 7rem !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  p {
    margin: 0;
    font-size: 10px;
    text-align: center;
  }
`;

const ChatGPTHistory = (props) => {
  const getCleanHistoricalPresetObject = (index) => {
    const rawPreset = props.messages.filter(
      (message) => message.role === "user" || message.role === "assistant"
    )[index]?.content;

    if (!rawPreset) {
      return null;
    } else {
      const preset = JSON.parse(JSON.parse(JSON.stringify(rawPreset)));
      if (typeof preset === "object" && preset !== null) {
        return preset;
      } else {
        return null;
      }
    }
  };
  const getHistoricalPreset = (index) => {
    const preset = getCleanHistoricalPresetObject(index);

    if (preset) {
      props.updatePreset(preset);
    } else {
      alert("The ChatGPT response is not a valid data object. Try again");
    }
  };

  return (
    <Messages>
      {props.messages
        .filter(
          (message) => message.role === "user" || message.role === "assistant"
        )
        .map((message, index) => {
          return message.role === "user" ? (
            <MessageBubble key={index}>{message.content}</MessageBubble>
          ) : (
            <div className="preset-holder">
              <RobotIcon />
              <PresetButton
                key={index}
                onClick={() => getHistoricalPreset(index)}
                type="button"
              >
                <PresetIcon preset={getCleanHistoricalPresetObject(index)} />
                <p>Use application</p>
              </PresetButton>
            </div>
          );
        })}
    </Messages>
  );
};

export default ChatGPTHistory;
